import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { CrudProvider } from '../../providers/crud/crud';
import { UtiltiyProvider } from '../../providers/utiltiy/utiltiy';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { KlmrJsaPage } from '../klmr-jsa/klmr-jsa';

@IonicPage()
@Component({
  selector: 'page-klmr-jsa-add',
  templateUrl: 'klmr-jsa-add.html',
})
export class KlmrJsaAddPage {
  fleetList: any = [];
  filledByList: any = [];
  selectedFleet: any;
  selectedRisk: any;
  selectedCCE: any;
  filledBy: any = [];
  selectOptions: any;
  createFuel: FormGroup;
  isUpdate: boolean = false;
  params: any = {};
  appColor: String;
  riskLevelOptions:any = [
    "E",
    "H",
    "M",
    "L"
  ];
  riskLevel: any = {
    "Catastrophic": {
      "Frequent": null,
      "Likely": null,
      "Occasional": null,
      "Seldom": null,
      "Unlikely": null
    },
    "Critical": {
      "Frequent": null,
      "Likely": null,
      "Occasional": null,
      "Seldom": null,
      "Unlikely": null
    },
    "Marginal": {
      "Frequent": null,
      "Likely": null,
      "Occasional": null,
      "Seldom": null,
      "Unlikely": null
    },
    "Negligible": {
      "Frequent": null,
      "Likely": null,
      "Occasional": null,
      "Seldom": null,
      "Unlikely": null
    }
  };
  actionAllowed:boolean = false;
  disableSubmit:boolean = false;

  constructor(public navCtrl: NavController, public navParams: NavParams, private api: CrudProvider, public utiltiy: UtiltiyProvider, private formBuilder: FormBuilder) {
    this.selectOptions = {
      mode: 'ios'
    };
    this.params = this.navParams.get('param');
    if (this.params) {
      this.isUpdate = true;

    }
    let currentDate = new Date()
     var d = new Date();
  let aeest = d.toLocaleString( "en-US", { timeZone: "Australia/Sydney"});
  let year = d.toLocaleString( "default", { year: "numeric" ,timeZone: "Australia/Sydney"});
  let month = d.toLocaleString( "default", { month: "2-digit" ,timeZone: "Australia/Sydney"});
  let day = d.toLocaleString( "default", { day: "2-digit" ,timeZone: "Australia/Sydney"});
  var date = year + "-" + month + "-" + day;
    this.createFuel = this.formBuilder.group({
      date: new FormControl(date, [Validators.required]),
      location: new FormControl('', [Validators.required]),
      task: new FormControl('', [Validators.required]),
      fleet_no: new FormControl('', [Validators.required]),
      team_member: new FormControl([], [Validators.required]),
      risk_show: new FormControl("", [Validators.required]),
      cce: new FormControl('', [Validators.required]),
      staff_username: new FormControl('', [Validators.required]),
      risk_level: new FormControl(''),
    });
    console.log("param", this.params)
  }

  ionViewDidLoad() {
    this.getPermission();
    this.getMetaData();

  }


  async getMetaData() {
    this.fleetList = await this.getFleetList();
    this.filledByList = await this.getFilledBtList();
    if (this.params) {
      this.regenerateForm();
    } else {
      var userName = await this.utiltiy.getStorage("name");
      this.createFuel.get('staff_username').setValue(userName);
    }
  }

  async getFleetList() {
    this.fleetList = [];
    this.utiltiy.startLoading();
    return this.api.get("/prestart/jsa/fleet/get", false)
      .then((result: any) => {
        console.log("result", result)
        this.utiltiy.stopLoading();
        if (result.status) {
          return result.result;
        }
      }, err => {
        this.utiltiy.stopLoading();
        this.utiltiy.toaster(err.error.message);
        return [];
      })
  }
  async getFilledBtList() {
    this.filledByList = [];
    this.utiltiy.startLoading();
    return this.api.get("/prestart/fuel/users/get", false)
      .then((result: any) => {
        console.log("result", result)
        result.result.forEach(element => {
          element.name = element.firstName + " " + element.surname;
        });
        this.utiltiy.stopLoading();
        if (result.status) {
          return result.result;
        }
      }, err => {
        this.utiltiy.stopLoading();
        this.utiltiy.toaster(err.error.message);
        return [];
      })
  }

  async regenerateForm() {
    var fillerBy = [];
    let status = this.params.team_member.includes(",");
    if (status) {
      fillerBy = this.params.team_member.split(",");
    } else {
      fillerBy = [this.params.team_member];
    }

    if (this.params.risk_show == "Yes") {
      let values = await this.regenerateRiskLevel(this.params.risk_level);
    }

    this.createFuel.patchValue({
      date: this.params.date,
      location: this.params.location,
      task: this.params.task,
      fleet_no: this.params.fleet_no,
      team_member: fillerBy,
      risk_show: this.params.risk_show,
      cce: this.params.cce,
      staff_username: this.params.staff_username,
    });
    this.filledBy = fillerBy;
    this.selectedCCE = this.params.cce,
      this.selectedRisk = this.params.risk_show,
      this.selectedFleet = this.params.fleet_no;
  }

  async regenerateRiskLevel(risk_level) {
    risk_level.forEach((risk_level_, i) => {
      this.riskLevel[risk_level_.severity][risk_level_.risk_type] = risk_level_.risk_code;
    return true;
    });
  }

  dropDownChange(value, key) {
    this.createFuel.get(`${key}`).setValue(value);
  }


  submit() {
    console.log("this.credentialsForm.value", this.createFuel.value)
    this.createFuel.value.risk_level = this.createFuel.value.risk_show == "Yes" ? this.riskLevel : {};
    var payload = {
      "formData": this.createFuel.value
    };
    this.utiltiy.startLoading();
    this.disableSubmit = true;

    if (this.isUpdate) {
      this.updateJsa(payload, this.params.id);
    } else {
      this.addJsa(payload);
    }


  }

  addJsa(formData) {
    this.api.post(`/prestart/jsa/store`, false, formData)
      .then((result: any) => {
        console.log("result", result)
    this.disableSubmit = false;

        this.utiltiy.stopLoading();
        if (result.status) {
          this.utiltiy.toaster(result.message);
          this.navCtrl.setRoot(KlmrJsaPage);
        }

      }, err => {
        console.log("err", err)
    this.disableSubmit = false;

        this.utiltiy.stopLoading();
        this.utiltiy.toaster(err.error.message);
      })
  }

  updateJsa(formData, id) {
    this.api.putWithourForm(`/prestart/jsa/update/${id}`, false, formData)
      .then((result: any) => {
        console.log("result", result)
    this.disableSubmit = false;

        this.utiltiy.stopLoading();
        if (result.status) {
          this.utiltiy.toaster(result.message);
          this.navCtrl.setRoot(KlmrJsaPage);
        }

      }, err => {
        console.log("err", err)
    this.disableSubmit = false;

        this.utiltiy.stopLoading();
        this.utiltiy.toaster(err.error.message);
      })
  }

  validateInput(group, key) {
    var value = this.riskLevel[group][key].toLowerCase();
    if (value == "e" || value == "h" || value == "m" || value == "l") {
      this.riskLevel[group][key] = value.toUpperCase();
    } else {
      this.riskLevel[group][key] = null;
      this.utiltiy.toaster("Only E,H,M,L allowed!");
    }

    console.log("riskLevel", this.riskLevel[group][key]);
    console.log("riskLevel", this.riskLevel);
  }

  async getPermission(){
    this.actionAllowed =  await this.utiltiy.getPagePermission("klmr-jsa-rw");
   }


}



// WEBPACK FOOTER //
// ./src/pages/klmr-jsa-add/klmr-jsa-add.ts